import { useState } from "react";

type Row = {
  id: string;
  data: any;
};

export type SelectRow = ({ id, data }: Row) => void;
export type UnselectRow = (id: string) => void;
export type RowsSelected = Row[];
export type SelectAll = (rows: Row[]) => void;
export type UnselectAll = (rows: string[]) => void;

export type Selectable = {
  rowsSelected: RowsSelected;
  selectRow: SelectRow;
  unselectRow: UnselectRow;
  selectAll: SelectAll;
  unselectAll: UnselectAll;
  disabled: boolean;
  clearSelection: () => void;
};

type Options = {
  maxRows?: number;
};

const defaultOptions = {
  maxRows: 50,
};

export const useTableSelectable = (
  options: Options = defaultOptions,
): Selectable => {
  const [rowsSelected, setSelectedRows] = useState<RowsSelected>([]);
  const disabled = rowsSelected.length >= (options.maxRows as number);

  const selectRow = (row: Row) => {
    return setSelectedRows([...rowsSelected, row]);
  };

  const unselectRow = (id: string) => {
    const rows = [...rowsSelected];
    const indexToRemove = rows.findIndex(
      (selectedRow) => selectedRow.id === id,
    );
    rows.splice(indexToRemove, 1);

    return setSelectedRows(rows);
  };

  const selectAll = (selectedRows: Row[]) => {
    const rows = [...rowsSelected];
    const isLimitReached = rows.length >= (options.maxRows as number);

    selectedRows.forEach((selectedRow) => {
      const isAlreadySelected = rows.find((row) => row.id === selectedRow.id);

      if (!isAlreadySelected && !isLimitReached) {
        const isLimitReached = (options.maxRows as number) <= rows.length;
        !isLimitReached && rows.push(selectedRow);
      }
    });

    return setSelectedRows(rows);
  };

  const unselectAll = (unselectedRows: string[]) => {
    const rows = [...rowsSelected].filter(
      ({ id }) => !unselectedRows.includes(id),
    );

    return setSelectedRows(rows);
  };

  const clearSelection = () => setSelectedRows([]);

  return {
    rowsSelected,
    selectRow,
    unselectRow,
    selectAll,
    unselectAll,
    disabled,
    clearSelection,
  };
};
